import { Headline } from "./Headline";

export type ProgressProps = {
    text:string;
    subtext:string;
    dismiss?:Function;
  }
  
export const Progress = (props:ProgressProps) => {
    if (!props || !props.text)
      return <div></div>;
    return <div className="ModalDialogBackground" >
    <Headline isDeveloper={false} />
    <div className="ModalDialogBox">
        <h3>{props.text}</h3>
        <hr></hr>
        <br></br>
        <small>{props.subtext}</small>
        <div style={{height:"5vh"}}/>
        {props.dismiss && <button onClick={()=>props.dismiss ? props.dismiss():null}>Dismiss</button>}
      </div>
    </div>
  }

 